module.exports = __webpack_public_path__ + "img/Rohstoffvorkommen.1d6a611e.png";